export enum GenericFileTypeEnum {
    /**
     * Unknown file.
     */
    FILE_UNKNOWN,
    /**
     * Operator logo.
     */
    FILE_LOGO,
    /**
     * Drone image
     */
    FILE_DRONE_IMAGE,
    /**
     * Generic file template
     */
    FILE_TEMPLATE,
    /**
     * Pilot photo
     */
    FILE_PILOT_PHOTO,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_00_01,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_00_02,

    /**
     * Coordination agreement.
     */
    FILE_COORDINATION_AGREEMENT,
    /**
     * Coordination agreement history line.
     */
    FILE_COORDINATION_HISTORY,
    /**
     * Operation details.
     */
    FILE_OPERATION_DETAILS,
    /**
     * Operation detail history.
     */
    FILE_OPERATION_DETAIL_HISTORY,
    /**
     * Daily operations by a drone operator.
     */
    FILE_DRONEOPERATOR_DAILY_OPERATIONS,
    /**
     * Daily operations by an infrastructure.
     */
    FILE_INFRASTRUCTURE_DAILY_OPERATIONS,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_01_01,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_01_02,


    /**
     * Drone insurance
     */
    FILE_DRONE_INSURANCE,
    /**
     * Pilot certification
     */
    FILE_PILOT_CERTIFICATION,
    /**
     * Operator certification
     */
    FILE_OPERATOR_CERTIFICATION,
    /**
     * Operator operational manual
     */
    FILE_OPERATOR_OPERATIONAL_MANUAL,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_02_01,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_02_02,

    /**
     * Operation EARO
     */
    FILE_OPERATION_EARO,
    /**
     * Operation SORA
     */
    FILE_OPERATION_SORA,
    /**
     * Scenario STS01
     */
    FILE_SCENARIO_STS_01,
    /**
     * Scenario STS02
     */
    FILE_SCENARIO_STS_02,
    /**
     * Certificate LUC
     */
    FILE_CERTIFICATE_LUC,
    /**
     * National Authorization
     */
    FILE_NATIONAL_AUTHORIZATION,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_03_01,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_03_02,

    /**
     * Coordination file previous to coordination
     */
    FILE_COORDINATION_REQUEST,
    /**
     * Coordination file previous to coordination
     */
    FILE_COORDINATION_GENERALITAT_PREVIOUS,
    /**
     * Communication to public safety agency
     */
    FILE_PUBLIC_SAFETY_COMMUNICATION,
    /**
     * Infrastructure authorization
     */
    FILE_INFRASTRUCTURE_AUTHORIZATION,
    /**
     * Reserved for future use
     */
    FILE_RECEIPT_OF_PROOF,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_04_01,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_04_02,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_04_03,
    /**
     * Reserved for future use
     */
    FILE_RESERVED_04_04
}